module.exports = __webpack_public_path__ + "img/gol.f59f45ec.gif";